import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  fetchCompany,
  fetchCompanyIntegrationSettings,
  fetchCompanySuccess,
  fetchCustomSettings,
  fetchSubsidiaries,
  fetchAdminSubsidiaries,
  fetchSubsidiariesSuccess,
  logoutAs
} from 'src/actions';
import superAdminNavConfig from 'src/layouts/Dashboard/superAdminNavConfig';
import { userRoles } from 'src/reducers/sessionReducer';

function AuthPersistor({ children }) {
  const session = useSelector(state => state.session);
  const history = useHistory();
  const dispatch = useDispatch();

  const loggedIn = session?.loggedIn;
  const user = session?.user;
  const userType = session?.userType;
  const superAdminPaths = superAdminNavConfig.map(navConf =>
    navConf.items
      .filter(item => item.href !== '/auth/logout')
      .map(item => item.href)
  );

  const mergedSuperPaths = Array.prototype.concat.apply([], superAdminPaths);
  useEffect(() => {
    if (loggedIn && user) {
      if (userType === userRoles.SUPERADMIN) {
        if (history.action !== 'POP') {
          history.push('/super/companies'); // Reload
        } else if (
          history.action === 'POP' &&
          window.location.pathname.includes('login') // new page
        ) {
          history.push('/super/companies');
        }
      } else if (
        userType === userRoles.ADMIN ||
        userType === userRoles.PLAY_AS
      ) {
        let inSuperPath = false;
        mergedSuperPaths.forEach(path => {
          if (path === window.location.pathname) {
            inSuperPath = true;
          }
        });
        if (userType === userRoles.PLAY_AS && inSuperPath) {
          dispatch(logoutAs());
          dispatch(fetchSubsidiariesSuccess(null));
          dispatch(fetchCompanySuccess(null));
          return
        }
        if (userType === userRoles.ADMIN) {
          fetchAdminStuffs();
        } else {
          fetchPlayAsStuffs();
        }
        if (history.action !== 'POP') {
          history.push('/overview');
        } else if (
          history.action === 'POP' &&
          window.location.pathname.includes('login')
        ) {
          history.push('/overview');
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn, userType]);

  const fetchAdminStuffs = async () => {
    await dispatch(fetchCompany());
    await dispatch(fetchCompanyIntegrationSettings());
    await dispatch(fetchCustomSettings());
    await dispatch(fetchAdminSubsidiaries());
  };
  const fetchPlayAsStuffs = async () => {
    const company = await dispatch(fetchCompany());
    await dispatch(fetchCompanyIntegrationSettings());
    await dispatch(fetchSubsidiaries(company?.id));
  };

  return <>{children}</>;
}

AuthPersistor.propTypes = {
  children: PropTypes.node
};

export default AuthPersistor;
